import {OverlayConfig} from "@angular/cdk/overlay";
import {Portal} from "@angular/cdk/portal";

export class DialogModel {
    public constructor(
        public config: OverlayConfig,
        public portal: Portal<any>
    ) {
    }
}
